/**
 * Created by deepak on 20-Mar-18.
 */

import React, { Component } from 'react';

class Errors extends Component {

    render() {
        let errorSpan = [];
        let key = 0;
        if (this.props.errorObject && this.props.errorObject.isError === true) {
            if (this.props.errorObject.required) {
                key = key + 1;
                errorSpan.push(<div className="alert alert-danger" key={key}>{this.props.errorObject.required}</div>)
            }
            if (this.props.errorObject.email) {
                key = key + 1;
                errorSpan.push(<div className="alert alert-danger" key={key}>{this.props.errorObject.email}</div>)

            }
            if (this.props.errorObject.pattern) {
                key = key + 1;
                errorSpan.push(<div className="alert alert-danger" key={key}>{this.props.errorObject.pattern}</div>)
            }
            if (this.props.errorObject.alpha) {
                key = key + 1;
                errorSpan.push(<div className="alert alert-danger" key={key}>{this.props.errorObject.alpha}</div>)
            }
            if (this.props.errorObject.max) {
                key = key + 1;
                errorSpan.push(<div className="alert alert-danger" key={key}>{this.props.errorObject.max}</div>)
            }
            if (this.props.errorObject.min) {
                key = key + 1;
                errorSpan.push(<div className="alert alert-danger" key={key}>{this.props.errorObject.min}</div>)
            }
        }
        if (this.props.errorObject && this.props.errorObject.isError === true && this.props.errorObject.messages && this.props.errorObject.messages.length > 0) {
            this.props.errorObject.messages.map(function (value, index) {
                key = key + 1;
                return errorSpan.push(<div className="alert alert-danger" key={key}>{value}</div>)
            })
        }
        if (this.props.errorObject && this.props.errorObject.isError === true && this.props.errorObject.message) {
            key = key + 1;
            errorSpan.push(<div className="alert alert-danger" key={key}>
                <div dangerouslySetInnerHTML={{__html: this.props.errorObject.message}}/>
            </div>)
        }
        if (this.props.errorObject && this.props.errorObject.isError === false && this.props.errorObject.message) {
            key = key + 1;
            errorSpan.push(<div className="alert alert-success" key={key}>{this.props.errorObject.message}</div>)
        }
        return (
            <React.Fragment>
                <div>
                    {errorSpan}
                </div>
            </React.Fragment>
        )
    }
}


export default Errors;


// WEBPACK FOOTER //
// ./src/components/common/Errors.js